import { useMap } from '@vis.gl/react-google-maps';
import React, { useEffect } from 'react';
import { useModules } from '../../contexts/ModulesContext/ModulesContext';

/** this is a little goofy that you have to return an empty div */
const GoogleTrafficLayer: React.FC = () => {
  const map = useMap();
  const [trafficLayerEnabled, setTrafficLayerEnabled] = React.useState(true);
  const { modulesEnabled } = useModules();
  const [trafficLayer, setTrafficLayer] =
    React.useState<google.maps.TrafficLayer>();

  useEffect(() => {
    setTrafficLayerEnabled(modulesEnabled['traffic']);
  }, [modulesEnabled]);

  useEffect(() => {
    if (map && !trafficLayer) {
      setTrafficLayer(new window.google.maps.TrafficLayer());
    }
    if (map && trafficLayerEnabled && trafficLayer) {
      trafficLayer.setMap(map);
    } else {
      if (trafficLayer) {
        trafficLayer.setMap(null);
      }
    }
  }, [map, trafficLayerEnabled, trafficLayer]);

  return <div></div>;
};

export default GoogleTrafficLayer;
